import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _protectActions, _protectMutations;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import axios from 'axios';
import Drip from 'drip';
import { API_GET_NAV_LIST, API_NEW_ARTISIT, API_NEW_TOUR_WISH, API_CATEGORY_MODULES, API_CATEGORY_MODULES_PREVIVE, API_PROJECT_FLOOR_MODULES, API_GIANT_FLOOR_MODULES } from '@/apis';
import { fetchMyShowPositions } from '@/request/home';
import { formatPositionItem, formatArtistListData, setModuleData, setCategoryData } from './formatData';
import { SET_NAVIGATION, SET_MODULES, SET_BANNER_LIST, SET_SLOT_MAP, SET_ARTIST_LIST, SET_PROJECT_FLOOR_LIST, SET_GIANT, MUTATE_NAVIGATION_LIST, MUTATE_CATEGORY_ID, MUTATE_BANNER_LIST, MUTATE_ARTIST_LIST, MUTATE_MODULE_DATA, MUTATE_CATEGORY_DATA, MUTATE_CLEAR_CATEGORY_DATA, GETTER_CUR_CATEGORY_DATA, GETTER_CUR_CATEGORY_BANNER_LIST, MUTATE_SHOW_TOUR_PART, idMapName, positionMap } from '@/constants/category-channel';

/**
 * 保护 State 代理函数
 * @param {Object} mutations 原始的 mutations 对象
 * @param {Array} blackList 禁止在 mutation 中读取的 key 列表
 */
export function protectMutations(mutations) {
  var blackList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['categoryId'];
  var protectedMutations = {};
  Object.keys(mutations).forEach(function (key) {
    var originalMutation = mutations[key];
    protectedMutations[key] = function (state, payload) {
      // 创建一个代理 state
      var proxyState = new Proxy(state, {
        get: function get(target, prop) {
          if (blackList.includes(prop)) {
            throw new Error("\u7981\u6B62\u5728 Mutation [".concat(key, "] \u4E2D\u76F4\u63A5\u8BFB\u53D6 state.").concat(prop, "\uFF01\n") + "\u539F\u56E0\uFF1A\u5F02\u6B65\u573A\u666F\u4E0B state.".concat(prop, " \u53EF\u80FD\u5DF2\u5931\u6548\u3002\n") + '解决：请从 payload 中获取该参数。');
          }
          return target[prop];
        },
        // 允许修改，但禁止读取
        set: function set(target, prop, value) {
          target[prop] = value;
          return true;
        }
      });

      // 执行原始 mutation，但传入的是代理后的 state
      return originalMutation(proxyState, payload);
    };
  });
  return protectedMutations;
}

/**
 * 保护 Actions：禁止在 action 中读取 state 的指定字段（如 categoryId）
 * 避免异步场景下 state 已变更导致数据错乱，强制从 payload 传入
 * @param {Object} actions 原始的 actions 对象
 * @param {Array} blackList 禁止在 action 中读取的 state key 列表
 */
export function protectActions(actions) {
  var blackList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['categoryId'];
  var protectedActions = {};
  Object.keys(actions).forEach(function (key) {
    var originalAction = actions[key];
    protectedActions[key] = function (context, payload) {
      var proxyState = new Proxy(context.state, {
        get: function get(target, prop) {
          if (blackList.includes(prop)) {
            throw new Error("\u7981\u6B62\u5728 Action [".concat(key, "] \u4E2D\u76F4\u63A5\u8BFB\u53D6 state.").concat(prop, "\uFF01\n") + "\u539F\u56E0\uFF1A\u5F02\u6B65\u573A\u666F\u4E0B state.".concat(prop, " \u53EF\u80FD\u5DF2\u5931\u6548\u3002\n") + '解决：请从 payload 中获取该参数并传入。');
          }
          return target[prop];
        }
      });
      return originalAction(Object.assign({}, context, {
        state: proxyState
      }), payload);
    };
  });
  return protectedActions;
}
function getDefaultShopDetail() {
  return {
    categoryId: '',
    navigationList: [],
    categoryListData: {},
    showTourPart: false,
    hasShowTourPartRequest: false
    // categoryListData数据结构
    // categoryListData: {
    //  0: {
    //    [idMapName[2]]: { data: []}
    //  }
    // }
  };
}

export default {
  namespaced: true,
  state: getDefaultShopDetail(),
  actions: protectActions((_protectActions = {}, _defineProperty(_protectActions, SET_NAVIGATION, function (_ref) {
    var _arguments = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var commit, state, _ref2, catchFunc;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit, state = _ref.state;
            _ref2 = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, catchFunc = _ref2.catchFunc;
            try {
              axios.get("".concat(API_GET_NAV_LIST)).then(function (_ref3) {
                var code = _ref3.code,
                  data = _ref3.data;
                if (code === 200) {
                  commit(MUTATE_NAVIGATION_LIST, data);
                }
              }).catch(function (err) {
                console.warn(err);
              });
            } catch (error) {
              catchFunc && catchFunc({
                error: error,
                text: '获取频道列表失败'
              });
            }
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }), _defineProperty(_protectActions, SET_MODULES, function (_ref4) {
    var _arguments2 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var commit, state, _ref5, failFunc, categoryId, successFunc, _window$location, search, isPreview, modulesApi;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref4.commit, state = _ref4.state;
            _ref5 = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : {}, failFunc = _ref5.failFunc, categoryId = _ref5.categoryId, successFunc = _ref5.successFunc;
            _context2.prev = 2;
            search = typeof window !== 'undefined' && window.location && ((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.search) || '';
            isPreview = /(?:\?|&)isPreview=true(?:&|$)/.test(search);
            modulesApi = isPreview ? API_CATEGORY_MODULES_PREVIVE : API_CATEGORY_MODULES;
            return _context2.abrupt("return", axios.get("".concat(modulesApi, "?categoryId=").concat(categoryId)).then(function (_ref6) {
              var success = _ref6.success,
                data = _ref6.data;
              if (success) {
                // const data = modules // mock
                var slotMap = {};
                data.forEach(function (_ref7, index) {
                  var moduleId = _ref7.moduleId;
                  slotMap[idMapName[moduleId]] = "position-".concat(index + 1);
                });
                successFunc && successFunc(slotMap, categoryId);
                commit(MUTATE_CATEGORY_DATA, {
                  data: slotMap,
                  key: 'slotMap',
                  categoryId: categoryId
                });
                commit(MUTATE_CATEGORY_DATA, {
                  data: data,
                  key: 'moduleListData',
                  categoryId: categoryId
                });
              } else {
                failFunc && failFunc({
                  error: '',
                  text: '品类频道获取模块信息失败'
                });
              }
            }).catch(function (err) {
              console.warn(err);
            }));
          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](2);
            failFunc && failFunc({
              error: _context2.t0,
              text: '品类频道获取模块信息失败'
            }, 'catch');
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 9]]);
    }))();
  }), _defineProperty(_protectActions, SET_BANNER_LIST, function (_ref8) {
    var _arguments3 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var commit, _ref9, failFunc, categoryId, positionId;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref8.commit;
            _ref9 = _arguments3.length > 1 && _arguments3[1] !== undefined ? _arguments3[1] : {}, failFunc = _ref9.failFunc, categoryId = _ref9.categoryId;
            _context3.prev = 2;
            positionId = positionMap[categoryId];
            if (positionId) {
              _context3.next = 7;
              break;
            }
            commit(MUTATE_MODULE_DATA, {
              data: [],
              type: 2,
              categoryId: categoryId
            });
            return _context3.abrupt("return");
          case 7:
            return _context3.abrupt("return", fetchMyShowPositions([positionId], 0, function () {
              failFunc && failFunc({
                error: '',
                text: '品类频道fetchMyShowPositions-error'
              });
            }).then(function (data) {
              // 格式化数据
              var _ref10 = data.find(function (item) {
                  return item.positionId === positionId;
                }) || {},
                adVOList = _ref10.adVOList;
              var bannerList = formatPositionItem(adVOList, {
                categoryId: categoryId
              });
              commit(MUTATE_MODULE_DATA, {
                data: bannerList,
                type: 2,
                categoryId: categoryId
              });
            }).catch(function (err) {
              console.warn(err);
            }));
          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](2);
            failFunc && failFunc({
              error: _context3.t0,
              text: '品类频道banner获取失败'
            }, 'catch');
          case 13:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[2, 10]]);
    }))();
  }), _defineProperty(_protectActions, SET_ARTIST_LIST, function (_ref11) {
    var _arguments4 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var commit, _ref12, failFunc, showTourPart, reqBackFun, categoryId, uuid, osName, params, _yield$axios$get, attrMaps, _yield$axios$get$data, data, success, arr, artistList;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            commit = _ref11.commit;
            _ref12 = _arguments4.length > 1 && _arguments4[1] !== undefined ? _arguments4[1] : {}, failFunc = _ref12.failFunc, showTourPart = _ref12.showTourPart, reqBackFun = _ref12.reqBackFun, categoryId = _ref12.categoryId;
            _context4.prev = 2;
            _context4.next = 5;
            return Drip.getUuid();
          case 5:
            uuid = _context4.sent;
            osName = Drip.UA.osName;
            params = {
              uuid: uuid,
              clientType: osName === 'ios' ? 1 : 4,
              os: osName === 'ios' ? 1 : 2,
              categoryId: categoryId,
              clientVersion: Drip.UA.appVersion,
              source: 2 // 1-首页 2-品类频道
            };

            _context4.next = 10;
            return axios.get("".concat(showTourPart ? API_NEW_TOUR_WISH : API_NEW_ARTISIT), {
              params: params
            });
          case 10:
            _yield$axios$get = _context4.sent;
            attrMaps = _yield$axios$get.attrMaps;
            _yield$axios$get$data = _yield$axios$get.data;
            data = _yield$axios$get$data === void 0 ? {} : _yield$axios$get$data;
            success = _yield$axios$get.success;
            // const {attrMaps, data = {}, success} = {data: artistListData, success: true, serverTime: 1772604896381}
            reqBackFun && reqBackFun({
              attrMaps: attrMaps,
              data: data,
              success: success
            });
            if (success) {
              arr = showTourPart ? data || [] : data && data.celebrityVoList || [];
              artistList = arr.filter(function (a) {
                return !!a;
              }).map(function (a, index) {
                return formatArtistListData(a, {
                  categoryId: categoryId,
                  index: index
                });
              }); // 参考idMapName type
              commit(MUTATE_MODULE_DATA, {
                data: artistList,
                type: showTourPart ? 11 : 6,
                categoryId: categoryId
              });
            } else {
              failFunc && failFunc({
                error: '',
                text: '品类频道艺人大咖获取失败'
              });
            }
            _context4.next = 22;
            break;
          case 19:
            _context4.prev = 19;
            _context4.t0 = _context4["catch"](2);
            failFunc && failFunc({
              error: _context4.t0,
              text: '品类频道艺人大咖获取失败'
            }, 'catch');
          case 22:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[2, 19]]);
    }))();
  }), _defineProperty(_protectActions, SET_PROJECT_FLOOR_LIST, function (_ref13) {
    var _arguments5 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var commit, _ref14, failFunc, successFunc, otherParams, categoryId, params, _yield$axios$get2, attrMaps, _yield$axios$get2$dat, data, success;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            commit = _ref13.commit;
            _ref14 = _arguments5.length > 1 && _arguments5[1] !== undefined ? _arguments5[1] : {}, failFunc = _ref14.failFunc, successFunc = _ref14.successFunc, otherParams = _ref14.otherParams, categoryId = _ref14.categoryId;
            _context5.prev = 2;
            params = Object.assign({
              categoryId: categoryId
            }, otherParams);
            _context5.next = 6;
            return axios.get("".concat(API_PROJECT_FLOOR_MODULES), {
              params: params
            });
          case 6:
            _yield$axios$get2 = _context5.sent;
            attrMaps = _yield$axios$get2.attrMaps;
            _yield$axios$get2$dat = _yield$axios$get2.data;
            data = _yield$axios$get2$dat === void 0 ? [] : _yield$axios$get2$dat;
            success = _yield$axios$get2.success;
            // const { data, success} = {data: projectFloor, success: true}
            if (success) {
              // 参考idMapName type
              commit(MUTATE_MODULE_DATA, {
                data: data,
                type: 9,
                categoryId: categoryId
              });
              successFunc && successFunc(data);
            } else {
              failFunc && failFunc({
                error: '',
                text: '品类频道项目楼层获取失败'
              });
            }
            _context5.next = 17;
            break;
          case 14:
            _context5.prev = 14;
            _context5.t0 = _context5["catch"](2);
            failFunc && failFunc({
              error: _context5.t0,
              text: '品类频道项目楼层获取失败'
            }, 'catch');
          case 17:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[2, 14]]);
    }))();
  }), _defineProperty(_protectActions, SET_GIANT, function (_ref15) {
    var _arguments6 = arguments;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var commit, _ref16, failFunc, otherParams, categoryId, params, _yield$axios$get3, attrMaps, giantResData, success;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            commit = _ref15.commit;
            _ref16 = _arguments6.length > 1 && _arguments6[1] !== undefined ? _arguments6[1] : {}, failFunc = _ref16.failFunc, otherParams = _ref16.otherParams, categoryId = _ref16.categoryId;
            _context6.prev = 2;
            params = Object.assign({
              categoryId: categoryId
            }, otherParams);
            _context6.next = 6;
            return axios.get("".concat(API_GIANT_FLOOR_MODULES), {
              params: params
            });
          case 6:
            _yield$axios$get3 = _context6.sent;
            attrMaps = _yield$axios$get3.attrMaps;
            giantResData = _yield$axios$get3.data;
            success = _yield$axios$get3.success;
            // const { data: giantResData, success} = {data: giantData, success: true}
            if (success) {
              commit(MUTATE_MODULE_DATA, {
                data: giantResData,
                type: 8,
                categoryId: categoryId
              });
              commit(MUTATE_MODULE_DATA, {
                data: giantResData && giantResData.favorStatus,
                type: 8,
                key: 'isCollect',
                categoryId: categoryId
              });
            } else {
              failFunc && failFunc({
                error: '',
                text: '品类频道巨无霸获取失败'
              });
            }
            _context6.next = 16;
            break;
          case 13:
            _context6.prev = 13;
            _context6.t0 = _context6["catch"](2);
            failFunc && failFunc({
              error: _context6.t0,
              text: '品类频道巨无霸获取失败'
            }, 'catch');
          case 16:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[2, 13]]);
    }))();
  }), _protectActions), ['categoryId']),
  mutations: protectMutations((_protectMutations = {}, _defineProperty(_protectMutations, MUTATE_CLEAR_CATEGORY_DATA, function (state) {
    var _ref17 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      stayCategoryId = _ref17.stayCategoryId;
    if (stayCategoryId != undefined) {
      var beforeCategoryData = state.categoryListData[stayCategoryId];
      state.categoryListData = _defineProperty({}, stayCategoryId, beforeCategoryData || {});
    } else {
      state.categoryListData = {};
    }
  }), _defineProperty(_protectMutations, MUTATE_NAVIGATION_LIST, function (state, navigationList) {
    state.navigationList = navigationList;
  }), _defineProperty(_protectMutations, MUTATE_CATEGORY_ID, function (state, categoryId) {
    state.categoryId = categoryId;
  }), _defineProperty(_protectMutations, MUTATE_SHOW_TOUR_PART, function (state, showTourPart) {
    state.showTourPart = showTourPart;
    state.hasShowTourPartRequest = true;
  }), _defineProperty(_protectMutations, MUTATE_MODULE_DATA, function (state, _ref18) {
    var data = _ref18.data,
      type = _ref18.type,
      _ref18$key = _ref18.key,
      key = _ref18$key === void 0 ? 'data' : _ref18$key,
      categoryId = _ref18.categoryId;
    // 2为banner
    var curCategoryListData = setModuleData({
      categoryListData: state.categoryListData,
      categoryId: categoryId,
      idMap: idMapName[type],
      data: data,
      key: key
    });
    state.categoryListData = curCategoryListData;
  }), _defineProperty(_protectMutations, MUTATE_CATEGORY_DATA, function (state, _ref19) {
    var data = _ref19.data,
      key = _ref19.key,
      categoryId = _ref19.categoryId;
    // 2为banner
    var curCategoryListData = setCategoryData({
      categoryListData: state.categoryListData,
      categoryId: categoryId,
      data: data,
      key: key
    });
    state.categoryListData = curCategoryListData;
  }), _protectMutations), ['categoryId']),
  getters: {
    curCategoryList: function curCategoryList(state) {
      return state.categoryListData && state.categoryListData[state.categoryId];
    },
    slotMap: function slotMap(state) {
      var curCategoryData = state.categoryListData && state.categoryListData[state.categoryId] || {};
      return curCategoryData.slotMap;
    },
    moduleListData: function moduleListData(state) {
      var curCategoryData = state.categoryListData && state.categoryListData[state.categoryId] || {};
      return curCategoryData.moduleListData;
    },
    bannerList: function bannerList(state) {
      var curCategoryData = state.categoryListData && state.categoryListData[state.categoryId] || {};
      return curCategoryData[idMapName[2]] && curCategoryData[idMapName[2]].data || [];
    },
    artistList: function artistList(state) {
      var showTourPart = state.showTourPart;
      var curCategoryData = state.categoryListData && state.categoryListData[state.categoryId] || {};
      var arr = curCategoryData[idMapName[showTourPart ? 11 : 6]] && curCategoryData[idMapName[showTourPart ? 11 : 6]].data || [];
      var artistList = arr.filter(function (a) {
        return !!a;
      }).map(function (a, index) {
        return formatArtistListData(a, {
          categoryId: state.categoryId,
          index: index
        });
      });
      return artistList;
    },
    projectFloor: function projectFloor(state) {
      var curCategoryData = state.categoryListData && state.categoryListData[state.categoryId] || {};
      return curCategoryData[idMapName[9]] && curCategoryData[idMapName[9]].data || [];
    },
    giantData: function giantData(state) {
      var curCategoryData = state.categoryListData && state.categoryListData[state.categoryId] || {};
      return curCategoryData[idMapName[8]] && curCategoryData[idMapName[8]].data;
    },
    giantIsCollect: function giantIsCollect(state) {
      var curCategoryData = state.categoryListData && state.categoryListData[state.categoryId] || {};
      return curCategoryData[idMapName[8]] && curCategoryData[idMapName[8]].isCollect;
    },
    brandPavilionStyleType: function brandPavilionStyleType(state) {
      var curCategoryData = state.categoryListData && state.categoryListData[state.categoryId] || {};
      return curCategoryData[idMapName[10]] && curCategoryData[idMapName[10]].brandPavilionStyleType || 0;
    },
    brandPavilionListData: function brandPavilionListData(state) {
      var curCategoryData = state.categoryListData && state.categoryListData[state.categoryId] || {};
      return curCategoryData[idMapName[10]] && curCategoryData[idMapName[10]].brandPavilionListData || [];
    },
    moduleRefresh: function moduleRefresh(state) {
      var curCategoryData = state.categoryListData && state.categoryListData[state.categoryId] || {};
      return curCategoryData.moduleRefresh || {};
    }
  }
};